<template>
  <div>
    <mia-settings-basics-templates-general-form />
  </div>
</template>

<script>
import TemplatesGeneralForm from '@/components/settings/forms/TemplatesGeneralForm.vue'

export default {
  name: 'MiaSettingsBasicsTemplate',

  components: {
    'mia-settings-basics-templates-general-form': TemplatesGeneralForm
  }
}
</script>
